import cn from 'clsx';
import { Wrapper } from '@ev-tech/ui-core-components/Wrapper';
import { Overline } from '@ev-tech/ui-core-components/Overline';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { EVLogoGG } from '@/components/common/Icons/EVLogoGG';

import type { IIntroProps } from './Intro.types';

import styles from './Intro.module.css';

export const Intro = ({ subtitle, headline, copy, nested, className, verticalLineTop, verticalLineBottom, ggArticle }: IIntroProps) => {
  const introContent = (
    <header
      className={cn(styles.intro, className)}
      data-has-vertical-line-on-top={verticalLineTop}
      data-has-vertical-line-on-bottom={verticalLineBottom}
    >
      <div className={styles.text} data-has-vertical-line={verticalLineBottom || verticalLineTop}>
        {ggArticle && (
          <div className={styles.logo}>
            <EVLogoGG />
          </div>
        )}
        {subtitle && <Overline className={styles.overline} text={subtitle} />}
        <Headline
          className={styles.headline}
          label={headline.label}
          size={headline.size}
          as={headline.as}
          data-has-copy={!!copy}
          data-gg-article={ggArticle}
        />
      </div>
      {!!copy && <Copy className={styles.copy} text={copy} size="xl" />}
    </header>
  );

  const IntroWithWrapper = (
    <Wrapper
      as="section"
      className={styles.wrapper}
      width={{ laptop: 'm', tabletLandscape: 'm' }}
      data-has-vertical-line-on-top={verticalLineTop}
    >
      {introContent}
    </Wrapper>
  );

  if (nested) {
    return <div className={styles.nestedWrapper}>{introContent}</div>;
  }

  return IntroWithWrapper;
};
